module.exports = __webpack_public_path__ + "img/trash_red.33cb3f25.svg";